export default "__VITE_ASSET__CEfELfqD__"